import React, { useState } from "react";
import classes from "./XOMediumMode.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
    resetTiles5Slice,
    setBoard,
    setIsHumanTurn,
} from "../../store/slices/xoGameSlice/tiles5Slice";
import AudioPlayer from "./AudioPlayer";
import AudioComputer from "./AudioComputer";
import { playXoMove } from "../../http/http";
import { removeUserToken } from "../../store/slices/userTokenSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import GameOverAnimation from "../../animations/gameOver.json";

const XOMediumMode = ({ gameAttemptId }) => {

    const dispatch = useDispatch();
    const { board, isHumanTurn } = useSelector(
        (state) => state?.persisted?.tiles5Slice
    );

    const [winner2,setWinner2]=useState("");

    const [soundX, setSoundX] = useState(false);
    const [soundO, setSoundO] = useState(false);

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const [gameOverLoading, setGameOverLoading] = useState(false);
    const [movePending, setMovePending] = useState(false);

    const { t } = useTranslation();
    const navigate = useNavigate();

    const savePoints = async (result, winner) => {
        if (gameOverLoading) {
            return;
        }
        setWinner2(winner);
        setGameOverLoading(true);
        navigate("/xo-game-over", { state: { result, winner, level: 2 } });
    };

    const handleCellClick = async (index) => {
        if (board[index] !== "" || !isHumanTurn || movePending) {
            return;
        }
        setSoundO(false);
        setSoundX(true);
        setMovePending(true);
        dispatch(setIsHumanTurn(false));
        try {
            const response = await playXoMove(gameAttemptId, index, userToken);
            const game = response.data.result;
            dispatch(setBoard(game.board));
            setSoundX(false);
            setSoundO(true);
            if (game.status === "continue") {
                dispatch(setIsHumanTurn(true));
            } else {
                const result = game.status === "win" ? "win" : game.status === "lose" ? "lose" : "draw";
                const winner = game.status === "win" ? "Player X won the game!" : game.status === "lose" ? "Player O won the game!" : "It's a Draw";
                savePoints(result, winner);
            }
        } catch (error) {
            dispatch(setIsHumanTurn(true));
            if (error?.response?.status === 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate("/");
            } else {
                toast.error(error?.response?.data?.error || "Unable to process this move. Please try again.");
            }
        } finally {
            setMovePending(false);
        }
    };

    return (
        <div className={classes.container}>
            <div className={classes.sub_container}>

                {soundX ? <AudioPlayer /> : soundO ? <AudioComputer /> : null}

                <div className={classes.player_turn_indicator}>
                    <h1>{isHumanTurn ? "Player X's Turn " : "Computer O's Turn"}</h1>
                </div>

                <div className={classes.grid_container}>
                    <img
                        src="/assets/images/background-grid.jpg"
                        className={classes.bg_img}
                    />
                    <div className={classes.grid}>
                        {board.map((cell, index) => (
                            <div
                                key={index}
                                className={`
                ${index === 0
                                        ? classes.tile_one
                                        : index === 1
                                            ? classes.tile_two
                                            : index === 2
                                                ? classes.tile_three
                                                : index === 3
                                                    ? classes.tile_four
                                                    : index === 4
                                                        ? classes.tile_five
                                                        : index === 5
                                                            ? classes.tile_six
                                                            : index === 6
                                                                ? classes.tile_seven
                                                                : index === 7
                                                                    ? classes.tile_eight
                                                                    : index === 8
                                                                        ? classes.tile_nine
                                                                        : index === 9
                                                                            ? classes.tile_ten
                                                                            : index === 10
                                                                                ? classes.tile_eleven
                                                                                : index === 11
                                                                                    ? classes.tile_twelve
                                                                                    : index === 12
                                                                                        ? classes.tile_thirteen
                                                                                        : index === 13
                                                                                            ? classes.tile_fourteen
                                                                                            : index === 14
                                                                                                ? classes.tile_fifteen
                                                                                                : index === 15
                                                                                                    ? classes.tile_sixteen
                                                                                                    : index === 16
                                                                                                        ? classes.tile_seventeen
                                                                                                        : index === 17
                                                                                                            ? classes.tile_eighteen
                                                                                                            : index === 18
                                                                                                                ? classes.tile_nineteen
                                                                                                                : index === 19
                                                                                                                    ? classes.tile_twenty
                                                                                                                    : index === 20
                                                                                                                        ? classes.tile_twenty_one
                                                                                                                        : index === 21
                                                                                                                            ? classes.tile_twenty_two
                                                                                                                            : index === 22
                                                                                                                                ? classes.tile_twenty_three
                                                                                                                                : index === 23
                                                                                                                                    ? classes.tile_twenty_four
                                                                                                                                    : index === 24
                                                                                                                                        ? classes.tile_twenty_five
                                                                                                                                        : index === 25
                                                                                                                                            ? classes.tile_twenty_six
                                                                                                                                            : index === 26
                                                                                                                                                ? classes.tile_twenty_seven
                                                                                                                                                : index === 27
                                                                                                                                                    ? classes.tile_twenty_eight
                                                                                                                                                    : index === 28
                                                                                                                                                        ? classes.tile_twenty_nine
                                                                                                                                                        : index === 29
                                                                                                                                                            ? classes.tile_thirty
                                                                                                                                                            : null
                                    }
              `}
                                onClick={() => handleCellClick(index)}
                                style={
                                    cell === "X"
                                        ? { color: "#e8d615" }
                                        : cell === "O"
                                            ? {
                                                color: "white",
                                            }
                                            : null
                                }
                            >
                                {cell}
                            </div>
                        ))}
                    </div>
                </div>
                <div className={classes.info}>
                    <h1>Place 4 in a row</h1>
                </div>

                {gameOverLoading && (
                    <div className={classes.game_over_animation_container}>
                        <Lottie animationData={GameOverAnimation} loop autoPlay className={classes.gameOverAnimation} />
                        <h1>{winner2}</h1>
                    </div>
                )}
            </div>
        </div>
    );
};

export default XOMediumMode;
